module.exports = __webpack_public_path__ + "static/media/rocket-league.e723e18d.jpg";